 <template>
  <div class="uk-margin-small">
    <div v-if="!isLoading">
      <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center uk-child-width-1-2" data-uk-grid>
        <div>
          <button type="button"
                  class="uk-button uk-button-danger uk-button-large_ uk-width-1-1 uk-padding-remove"
                  @click="showDialog('showDialog1')">
            {{ local_page_keys.button_not_good }}
          </button>
        </div>
        <div>
          <button type="button"
                  class="uk-button uk-button-success uk-button-large_ uk-width-1-1 uk-padding-remove"
                  @click="submitOrder('done-admin')">
            <md-icon class="uk-margin-small-right">done</md-icon>
            {{ local_page_keys.button_accepted_for_senior }}
          </button>
        </div>
<!--        <div>-->
<!--          <button type="button"-->
<!--                  class="uk-button tm-button-education uk-button-large_ uk-width-1-1 uk-padding-remove"-->
<!--                  @click="showDialogEdu = true">-->
<!--            <md-icon class="uk-margin-small-right">done</md-icon>-->
<!--            {{ local_page_keys.button_edu }}-->
<!--          </button>-->
<!--        </div>-->
      </div>
    </div>

    <!--диалоговое окно замечаний проверяющего-->
    <md-dialog
        class="tm-check-dialog"
        :md-active.sync="showDialog1"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true">
      <div class="uk-padding-xsmall uk-position-relative tm-modal-page">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="closeDialog">
          <span class="material-icons">close</span>
        </a>
        <div class="uk-grid uk-grid-small">
          <!--левая часть-->
          <div class="uk-width-auto">
            <div class="uk-position-relative">
              <div class="uk-grid uk-grid-collapse uk-flex-middle">
                <div class="tm-block-img uk-text-center"
                     @mousemove="beforeModalVisible = true; afterModalVisible = false"
                     @mouseleave="beforeModalVisible = false; afterModalVisible = true">
                  <div class="image-wrapper">
                    <div v-if="beforeModalVisible"
                         class="uk-inline-clip uk-transition-toggle left-part-main-photo  main-photo-dialog">
                      <img v-if="fixedPhoto.image === null" :src=main_photo_before alt=""
                           class="left-part-main-photo main-photo-image">
                      <img
                          v-else-if="fixedPhoto.image === null && main_photo_after === null && main_photo_before !== null"
                          :src="main_photo_before" alt="" class="left-part-main-photo main-photo-image">
                      <img
                          v-else-if="fixedPhoto.image !== null && main_photo_after !== null && main_photo_before !== null"
                          :src="main_photo_after" alt="" class="left-part-main-photo main-photo-image">
                      <img
                          v-else-if="fixedPhoto.image !== null && main_photo_after === null && main_photo_before !== null"
                          :src="main_photo_before" alt="" class="left-part-main-photo main-photo-image">
                      <img v-else src="/img/images.png" alt="" class="left-part-main-photo main-photo-image">
                    </div>
                    <div v-if="afterModalVisible"
                         class="uk-inline-clip uk-transition-toggle left-part-main-photo  main-photo-dialog">
                      <img v-if="fixedPhoto.image === null && main_photo_after !== null"
                           class="left-part-main-photo main-photo-image" :src="main_photo_after" alt="">
                      <img
                          v-else-if="fixedPhoto.image === null && main_photo_after === null && main_photo_before !== null"
                          class="left-part-main-photo main-photo-image" :src="main_photo_before" alt="">
                      <img
                          v-else-if="fixedPhoto.image === null && main_photo_after === null && main_photo_before === null"
                          class="left-part-main-photo main-photo-image" src="/img/images.png" alt="">
                      <img v-else :src="fixedPhoto.image" alt="" class="left-part-main-photo main-photo-image">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--правая часть-->
          <div class="uk-width-expand">
            <!--скрыто в рамках 537 таска-->
            <div v-if=false>
              <!--список замечаний-->
              <div v-if="loadingInfo" class="uk-grid uk-grid-collapse uk-child-width-auto uk-margin-top tm-modal-checkbox-list scrollable-dialog">
                <v-progress-circular
                    :width="2"
                    indeterminate
                    style="color: forestgreen"></v-progress-circular>
              </div>
              <div v-else class="uk-grid uk-grid-collapse uk-child-width-auto uk-margin-top tm-modal-checkbox-list scrollable-dialog">
                <div v-for="face of Object.keys(faces)"
                     :key="face.index"
                     class="uk-margin-small-top checkFunctions">
                  <div class="check-functions-lables uk-margin-small-bottom uk-width-1-1" v-if="face == 'Total Order'">
                    {{ local_page_keys.label_general }}:
                  </div>
                  <div class="check-functions-lables uk-margin-small-bottom uk-width-1-1" v-else>
                    {{ local_page_keys.label_face }}{{ face.slice(-2) }}:
                  </div>
                  <div v-for="value of Object.keys(faces[face])"
                       :key="value.index"
                       class="tm-modal-checkbox-list-item uk-margin-small-bottom"
                       id="checkedFunctions">
                    <input type="checkbox"
                           :id="face + faces[face][value].RU"
                           :name="face + faces[face][value].RU"
                           v-model="checked"
                           :value="face + ':' + faces[face][value].RU" @input="removeCheckedClass">
                    <label :for="face + faces[face][value].RU">
                      {{ faces[face][value].RU }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!--выпадающие списки только для сеньера-->
            <!--скрыто в рамках 537 таска-->
            <div v-if=false class="uk-grid uk-grid-small uk-child-width-1-2" data-uk-grid>
              <div>
                <v-select id="validatedProblemSelect"
                    :options="functionListProblems"
                    label="text"
                    :reduce="_problem => _problem.value"
                    multiple
                    v-model="functionListSelectedProblem"
                    placeholder="Чья проблема*"
                    :clearable="true"
                    class="tm-v-select">
                  <template #search="{attributes, events}">
                    <input
                        class="vs__search"
                        :required="!functionListSelectedProblem"
                        v-bind="attributes"
                        v-on="events"/>
                  </template>
                </v-select>
              </div>
              <div>
                <v-select
                    :options="functionList"
                    label="text"
                    :reduce="_function => _function.value"
                    multiple
                    v-model="functionListSelectedVideo"
                    placeholder="Видео"
                    :clearable="true"
                    class="tm-v-select">
                </v-select>
              </div>
              <div>
                <v-select
                    :options="functionList"
                    label="text"
                    :reduce="_function => _function.value"
                    multiple
                    v-model="functionListSelectedExample"
                    placeholder="Примеры"
                    :clearable="true"
                    class="tm-v-select">
                </v-select>
              </div>
              <div>
                <v-select
                    :options="functionList"
                    label="text"
                    :reduce="_function => _function.value"
                    multiple
                    v-model="functionListSelectedDescription"
                    placeholder="Описание"
                    :clearable="true"
                    class="tm-v-select">
                </v-select>
              </div>
            </div>

            <!--поле для комментария ретушеру-->
            <!--скрыто в рамках 537 таска-->
            <div v-if=false class="uk-margin-small-top">
              <md-field style="margin:0;padding-bottom: 0;border-top: 1px solid rgb(210, 210, 210);border-left: 1px solid rgb(210, 210, 210);border-right: 1px solid rgb(210, 210, 210);">
                <label>{{ local_page_keys.ordercheck_to_retoucher }} {{ selectedUsersForComment.retoucher }}</label>
                <md-textarea class="tm-check-dialog-textarea" v-model="textarea1" id="validatedTextArea" @input="removeCheckedClass" style="min-height: 60px"></md-textarea>
              </md-field>
            </div>

            <!--поле для комментария проверяющему-->
            <div class="uk-margin-large-top uk-position-relative">
              <md-field style="margin:0;padding-bottom: 0;border-top: 1px solid rgb(210, 210, 210);border-left: 1px solid rgb(210, 210, 210);border-right: 1px solid rgb(210, 210, 210);">
                <label>{{ local_page_keys.ordercheck_to_verifier }} {{ selectedUsersForComment.pro_retoucher }}</label>
                <md-textarea class="tm-check-dialog-textarea" v-model="textarea2" id="validatedTextArea" @input="removeCheckedClass" style="min-height: 260px;padding-bottom: 110px;"></md-textarea>
              </md-field>
              <!--готовые ответы-->
              <div class="uk-position-bottom-left uk-padding-small">
                <div class="uk-grid tm-grid-xsmall uk-text-small uk-child-width-1-1" data-uk-grid>
                  <div v-for="(response, index) in quickResponses" :key="index">
                    <div @click="insertQuickResponses(response)" class="uk-label tm-label tm-label-hover uk-text-truncate" style="cursor: pointer;white-space: inherit;">
                     {{response}}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- чек для оценки выполненной работы. По умолчанию плохо - чекбокс не отмечен. Слишком плохо - чекбокс отмечен -->
<!--            <div class="uk-margin-small-top" v-if="prev_status_order != 'hold-admin-new'">-->
<!--              <div>-->
<!--                <label><input v-model="problemLevel" id="problemLevelCheckbox" class="uk-checkbox uk-margin-small-right" type="checkbox" value="1"/> {{local_page_keys.option_too_bad}}</label>-->
<!--              </div>-->
<!--            </div>-->

            <!--поле для тг канала-->
            <!--скрыто в рамках 537 таска-->
            <div v-if=false class="uk-margin-small-top">
              <div>
                <label>
                  <input v-model="commentForTelegram"
                         class="uk-checkbox uk-margin-small-right"
                         name="telegrammCheckbox"
                         type="checkbox"
                         data-uk-toggle="target: #comment_for_telegram; animation: uk-animation-slide-top-small, uk-animation-slide-bottom-small">
                  {{ local_page_keys.ordercheck_comment_for_telegram }}
                </label>
              </div>
              <div class="uk-margin-small-top" v-if="commentForTelegram">
                <div class="uk-padding-small uk-background-muted uk-margin-large-bottom">
                  <md-field style="margin:0;padding-bottom: 0;border-top: 1px solid rgb(210, 210, 210);border-left: 1px solid rgb(210, 210, 210);border-right: 1px solid rgb(210, 210, 210);">
                    <label>{{ local_page_keys.label_add_a_comment }}</label>
                    <md-textarea class="tm-check-dialog-textarea" v-model="textarea3" id="validatedTextArea3" @input="removeTextAreaClass" style="min-height: 60px"></md-textarea>
                  </md-field>
                  <!--скриншот для тг канала-->
                  <div class="uk-margin-small">
<!--                    <div class="uk-margin-small-bottom">-->
<!--                      {{ local_page_keys.ordercheck_download_screenshot_for_telegram }}-->
<!--                    </div>-->
                    <div>
                      <MultipleImgUploadComponent :keys_pages="local_page_keys" :files="files"></MultipleImgUploadComponent>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- чек для Халтурная работа -->
            <div class="uk-margin-small-top" v-if="!isSloppyWorkExist()">
              <div>
                <label><input v-model="sloppyWork" :disabled="putToVote && isPutToVote" class="uk-checkbox uk-margin-small-right" type="checkbox" value="1"/> {{local_page_keys.sloppy_work_label}} -10%</label>
              </div>
            </div>

            <!-- чек для Вынести на голосование -->
            <div class="uk-margin-small-top" v-if="isPutToVote">
              <div>
                <label><input v-model="putToVote" :disabled="sloppyWork" class="uk-checkbox uk-margin-small-right" type="checkbox" value="1"/> {{local_page_keys.put_to_vote}}</label>
              </div>
            </div>

            <!-- чек для Принято пояснение от проверяющего -->
            <div class="uk-margin-small-top" v-if="isProRetoucherComment()">
              <div>
                <label><input v-model="acceptedFromInspector"  class="uk-checkbox uk-margin-small-right" type="checkbox" value="1"/> {{local_page_keys.accepted_from_inspector}}</label>
              </div>
            </div>

            <!-- чек для copy order for education for selected retoucher -->
            <!--скрыто в рамках 537 таска-->
            <div v-if=false class="uk-margin-small-top">
            <!--<div class="uk-margin-small-top" v-if="prev_status_order != 'hold-admin-new'">-->
              <div>
                <label><input v-model="sendToEducation" id="sendToEducation" class="uk-checkbox uk-margin-small-right" type="checkbox" value="1"/> {{local_page_keys.button_edu}}</label>
              </div>
            </div>

            <!--кнопка отправки комментария-->
            <div class="uk-grid uk-grid-small uk-child-width-1-2 uk-flex-center uk-margin-top">
              <!--скрыто в рамках 537 таска-->
              <div v-if=false>
                <button type="button"
                        v-if="!showDialog9"
                        class="uk-button uk-button-default uk-button-large_ uk-width-1-1 uk-padding-remove"
                        @click="showDialog9 = true">
                  <md-icon class="uk-margin-small-right">mode_edit</md-icon>
                  {{ local_page_keys.label_add_notes }}
                </button>
                <button type="button"
                        v-else
                        class="uk-button uk-button-default uk-button-large_ uk-width-1-1 uk-padding-remove"
                        @click="classDisplay = ''">
                  <md-icon class="uk-margin-small-right">mode_edit</md-icon>
                  {{ local_page_keys.button_add_notes }}
                </button>
              </div>
              <div>
                <button type="button"
                        class="uk-button uk-button-danger uk-button-large_ uk-width-1-1 uk-padding-remove"
                        @click="submitComments">
                  <md-icon class="uk-margin-small-right">mail</md-icon>
                  {{ local_page_keys.button_send }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </md-dialog>
    <!--диалоговое окно замечаний проверяющего для отправки для обучения-->
    <md-dialog
        class="tm-check-dialog"
        :md-active.sync="showDialogEdu"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true">
      <div class="uk-padding-xsmall uk-position-relative tm-modal-page">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="closeDialog">
          <span class="material-icons">close</span>
        </a>
        <div class="uk-grid uk-grid-small">
          <!--левая часть-->
          <div class="uk-width-auto">
            <div class="uk-position-relative">
              <div class="uk-grid uk-grid-collapse uk-flex-middle">
                <div class="tm-block-img uk-text-center"
                     @mousemove="beforeModalVisible = true; afterModalVisible = false"
                     @mouseleave="beforeModalVisible = false; afterModalVisible = true">
                  <div class="image-wrapper">
                    <div v-if="beforeModalVisible"
                         class="uk-inline-clip uk-transition-toggle left-part-main-photo  main-photo-dialog">
                      <img v-if="fixedPhoto.image === null" :src=main_photo_before alt=""
                           class="left-part-main-photo main-photo-image">
                      <img
                          v-else-if="fixedPhoto.image === null && main_photo_after === null && main_photo_before !== null"
                          :src="main_photo_before" alt="" class="left-part-main-photo main-photo-image">
                      <img
                          v-else-if="fixedPhoto.image !== null && main_photo_after !== null && main_photo_before !== null"
                          :src="main_photo_after" alt="" class="left-part-main-photo main-photo-image">
                      <img
                          v-else-if="fixedPhoto.image !== null && main_photo_after === null && main_photo_before !== null"
                          :src="main_photo_before" alt="" class="left-part-main-photo main-photo-image">
                      <img v-else src="/img/images.png" alt="" class="left-part-main-photo main-photo-image">
                    </div>
                    <div v-if="afterModalVisible"
                         class="uk-inline-clip uk-transition-toggle left-part-main-photo  main-photo-dialog">
                      <img v-if="fixedPhoto.image === null && main_photo_after !== null"
                           class="left-part-main-photo main-photo-image" :src="main_photo_after" alt="">
                      <img
                          v-else-if="fixedPhoto.image === null && main_photo_after === null && main_photo_before !== null"
                          class="left-part-main-photo main-photo-image" :src="main_photo_before" alt="">
                      <img
                          v-else-if="fixedPhoto.image === null && main_photo_after === null && main_photo_before === null"
                          class="left-part-main-photo main-photo-image" src="/img/images.png" alt="">
                      <img v-else :src="fixedPhoto.image" alt="" class="left-part-main-photo main-photo-image">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--правая часть-->
          <div class="uk-width-expand">
            <!--список замечаний-->
            <div v-if="loadingInfo"
                 class="uk-grid uk-grid-collapse uk-child-width-auto uk-margin-top tm-modal-checkbox-list scrollable-dialog">
              <v-progress-circular
                  :width="2"
                  indeterminate
                  style="color: forestgreen"
              ></v-progress-circular>
            </div>
            <div v-else class="uk-grid uk-grid-collapse uk-child-width-auto uk-margin-top tm-modal-checkbox-list scrollable-dialog">
              <div v-for="face of Object.keys(faces)"
                   :key="face.index"
                   class="uk-margin-small-top checkFunctions">

                <div class="check-functions-lables uk-margin-small-bottom uk-width-1-1" v-if="face == 'Total Order'">
                  {{ local_page_keys.label_general }}:
                </div>
                <div class="check-functions-lables uk-margin-small-bottom uk-width-1-1" v-else>
                  {{ local_page_keys.label_face }}{{ face.slice(-2) }}:
                </div>
                <div v-for="value of Object.keys(faces[face])"
                     :key="value.index"
                     class="tm-modal-checkbox-list-item uk-margin-small-bottom"
                     id="checkedFunctions">
                  <input type="checkbox"
                         :id="face + faces[face][value].RU"
                         :name="face + faces[face][value].RU"
                         v-model="checked"
                         :value="face + ':' + faces[face][value].RU" @input="removeCheckedClass">
                  <label :for="face + faces[face][value].RU">
                    {{ faces[face][value].RU }}
                  </label>
                </div>
              </div>
            </div>

            <!--выпадающие списки только для сеньера-->
            <div class="uk-grid uk-grid-small uk-child-width-1-2" data-uk-grid>
              <div>
                <v-select id="validatedProblemSelect"
                          :options="functionListProblems"
                          label="text"
                          :reduce="_problem => _problem.value"
                          multiple
                          v-model="functionListSelectedProblem"
                          placeholder="Чья проблема*"
                          :clearable="true"
                          class="tm-v-select">
                  <template #search="{attributes, events}">
                    <input
                        class="vs__search"
                        :required="!functionListSelectedProblem"
                        v-bind="attributes"
                        v-on="events"/>
                  </template>
                </v-select>
              </div>
              <div>
                <v-select
                    :options="functionList"
                    label="text"
                    :reduce="_function => _function.value"
                    multiple
                    v-model="functionListSelectedVideo"
                    placeholder="Видео"
                    :clearable="true"
                    class="tm-v-select">
                </v-select>
              </div>
              <div>
                <v-select
                    :options="functionList"
                    label="text"
                    :reduce="_function => _function.value"
                    multiple
                    v-model="functionListSelectedExample"
                    placeholder="Примеры"
                    :clearable="true"
                    class="tm-v-select">
                </v-select>
              </div>
              <div>
                <v-select
                    :options="functionList"
                    label="text"
                    :reduce="_function => _function.value"
                    multiple
                    v-model="functionListSelectedDescription"
                    placeholder="Описание"
                    :clearable="true"
                    class="tm-v-select">
                </v-select>
              </div>
            </div>

            <!--поле для комментария ретушеру-->
            <div class="uk-margin-small-top">
              <!--              <div class="uk-margin-small">-->
              <!--                {{ local_page_keys.ordercheck_to_retoucher }}:-->
              <!--              </div>-->
              <md-field style="margin:0;padding-bottom: 0;border-top: 1px solid rgb(210, 210, 210);border-left: 1px solid rgb(210, 210, 210);border-right: 1px solid rgb(210, 210, 210);">
                <label>{{ local_page_keys.ordercheck_to_retoucher }} {{ selectedUsersForComment.retoucher }}</label>
                <md-textarea class="tm-check-dialog-textarea" v-model="textarea1" id="validatedTextArea" @input="removeCheckedClass" style="min-height: 60px"></md-textarea>
              </md-field>
            </div>
            <!--поле для комментария проверяющему-->
            <div class="uk-margin-small-top">
              <!--              <div class="uk-margin-small">-->
              <!--                {{ local_page_keys.ordercheck_to_verifier }}:-->
              <!--              </div>-->
              <md-field style="margin:0;padding-bottom: 0;border-top: 1px solid rgb(210, 210, 210);border-left: 1px solid rgb(210, 210, 210);border-right: 1px solid rgb(210, 210, 210);">
                <label>{{ local_page_keys.ordercheck_to_verifier }} {{ selectedUsersForComment.pro_retoucher }}</label>
                <md-textarea class="tm-check-dialog-textarea" v-model="textarea2" id="validatedTextArea" @input="removeCheckedClass" style="min-height: 60px"></md-textarea>
              </md-field>
            </div>

            <!-- чек для оценки выполненной работы. По умолчанию плохо - чекбокс не отмечен. Слишком плохо - чекбокс отмечен -->
<!--            <div class="uk-margin-small-top" v-if="prev_status_order != 'hold-admin-new'">-->
<!--              <div>-->
<!--                <label><input v-model="problemLevel" id="problemLevelCheckbox" class="uk-checkbox uk-margin-small-right" type="checkbox" value="1"/> {{local_page_keys.option_too_bad}}</label>-->
<!--              </div>-->
<!--            </div>-->

            <!-- чек для Халтурная работа -->
            <div class="uk-margin-small-top">
              <div>
                <label><input v-model="sloppyWork"  class="uk-checkbox uk-margin-small-right" type="checkbox" value="1"/> {{local_page_keys.sloppy_work_label}}-10%</label>
              </div>
            </div>

            <!-- чек для Принято пояснение от проверяющего -->
            <div class="uk-margin-small-top" v-if="isProRetoucherComment()">
              <div>
                <label><input v-model="acceptedFromInspector"  class="uk-checkbox uk-margin-small-right" type="checkbox" value="1"/> {{local_page_keys.accepted_from_inspector}}</label>
              </div>
            </div>

            <!--поле для тг канала-->
            <div class="uk-margin-small-top">
              <div>
                <label>
                  <input v-model="commentForTelegram"
                         class="uk-checkbox uk-margin-small-right"
                         name="telegrammCheckbox"
                         type="checkbox"
                         data-uk-toggle="target: #comment_for_telegram; animation: uk-animation-slide-top-small, uk-animation-slide-bottom-small">
                  {{ local_page_keys.ordercheck_comment_for_telegram }}
                </label>
              </div>
              <div class="uk-margin-small-top" v-if="commentForTelegram">
                <div class="uk-padding-small uk-background-muted uk-margin-large-bottom">
                  <md-field style="margin:0;padding-bottom: 0;border-top: 1px solid rgb(210, 210, 210);border-left: 1px solid rgb(210, 210, 210);border-right: 1px solid rgb(210, 210, 210);">
                    <label>{{ local_page_keys.label_add_a_comment }}</label>
                    <md-textarea class="tm-check-dialog-textarea" v-model="textarea3" id="validatedTextArea3" @input="removeTextAreaClass" style="min-height: 60px"></md-textarea>
                  </md-field>
                  <!--скриншот для тг канала-->
                  <div class="uk-margin-small">
                    <!--                    <div class="uk-margin-small-bottom">-->
                    <!--                      {{ local_page_keys.ordercheck_download_screenshot_for_telegram }}-->
                    <!--                    </div>-->
                    <div>
                      <MultipleImgUploadComponent :keys_pages="local_page_keys" :files="files"></MultipleImgUploadComponent>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--кнопка отправки комментария-->
            <div class="uk-grid uk-grid-small uk-child-width-1-2 uk-margin-top">
              <div>
                <button type="button"
                        v-if="!showDialog9"
                        class="uk-button uk-button-default uk-button-large uk-width-1-1"
                        @click="showDialog9 = true">
                  <md-icon class="uk-margin-small-right">mode_edit</md-icon>
                  {{ local_page_keys.label_add_notes }}
                </button>
                <button type="button"
                        v-else
                        class="uk-button uk-button-default uk-button-large uk-width-1-1"
                        @click="classDisplay = ''">
                  <md-icon class="uk-margin-small-right">mode_edit</md-icon>
                  {{ local_page_keys.button_add_notes }}
                </button>
              </div>
              <div>
                <button type="button"
                        class="uk-button uk-button-danger uk-button-large_ uk-width-1-1 uk-padding-remove"
                        @click="submitComments">
                  <md-icon class="uk-margin-small-right">mail</md-icon>
                  {{ local_page_keys.button_send }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </md-dialog>
    <md-dialog
        class="tm-check-dialog"
        :md-active.sync="showDialog9"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true"
        :class="classDisplay"
        ref="commentPhoto">
      <div class="uk-padding uk-position-relative tm-modal-page 3">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="classDisplay = 'display'">
          <span class="material-icons">close</span>
        </a>
        <comment-photo v-model="fixedPhoto"
                       :src-image="(main_photo_after !== null ? main_photo_after : main_photo_before)"
                       :width="canvasWidth"
                       :height="canvasHeight"
                       @image="fixedPhoto.image = $event"
                       @fields="fixedPhoto.fields = $event"
                       @classDisplay="classDisplay = $event"
                       @reset="fixedPhoto.image = $event; fixedPhoto.fields = $event"></comment-photo>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import CommentPhoto from "@/pages/Dashboard/Components/CommentPhoto";

import MultipleImgUploadComponent from "@/pages/Dashboard/Components/MultipleImgUploadComponent";
import convertBase64ToBlob from '../../../../filters/convertBase64ToBlob.js';

export default {
  name: "ActivitiesOfSeniorRetoucher",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    faces: {
      type: Array,
      require: true
    },
    local_page_keys: {
      type: Object,
      require: true
    },
    main_photo_after: {
      require: true
    },
    main_photo_before: {
      require: true
    },
    prev_status_order: {
      type: String,
      require: true
    },
    canvasWidth: {
      type: Number,
      require: true
    },
    canvasHeight: {
      type: Number,
      require: true
    },
    order_id: {
      type: Number,
      require: true
    },
    cost: {
      type: Number,
      require: true
    },
    order_number: {
      type: String,
      require: true
    },
    role: {
      type: String,
      require: true
    },
    getNewOrder:{
      type: Boolean,
      default:true
    },
    order_chat: {
      require: true
    },
    orderWeekComment: Number
  },
  filters: {
    convertBase64ToBlob
  },
  data: () => ({
    loadingInfo: false,
    classDisplay: '',
    showDialog1: false,
    showDialogEdu: false,
    showDialog9: false,
    isLoading: false,
    beforeModalVisible: false,
    afterModalVisible: false,
    fixedPhoto: {
      image: null,
      fields: null,
    },
    selectedLevel: '',
    problemLevel: false,
    sendToEducation: false,
    checked: [],
    textarea1: null,
    commentForTelegram: false,
    textarea2: '',
    textarea3: '',
    files: [],
    functionList:[],
    functionListSelectedVideo:[],
    functionListSelectedExample:[],
    functionListSelectedDescription:[],
    functionListSelectedProblem:[],
    functionListProblems:[
      // {text:'Чья проблема', value:1},
      {text:'Ретушер+проверяющий', value:'Ретушер+проверяющий'},
      {text:'Проверяющий', value:'Проверяющий'},
      {text:'Примеры', value:'Примеры'},
      {text:'Видео', value:'Видео'},
      {text:'Описание', value:'Описание'},
      {text:'Доп файлы', value:'Доп файлы'},
      {text:'Система', value:'Система'},
      {text:'Клиент', value:'Клиент'},
      {text:'Не понятно', value:'Не понятно'},
      {text:'Просит доп', value:'Просит доп'},
    ],
    selectedUsersForComment: {
      pro_retoucher: null,
      retoucher: {
        email: null,
        version: null,
      }
    },
    lastUsersForComment: {
      pro_retoucher: null,
      retoucher: null
    },
    acceptedFromInspector: false,
    sloppyWork: false,
    quickResponses: [
        'Итог ретуши выглядит неаккуратно/непривлекательно',
        'Допущены ошибки, сильно искажающие и анатомически уродующие человека/объект (клиент не требовал этого)',
        'Небрежная проверка, допущены очевидные ляпы'
    ],
    adminComments: [],
    putToVote: false
  }),
  components: {
    CommentPhoto,
    MultipleImgUploadComponent
  },
  methods: {
    /**
     *  send request order 'done-admin' or 'rejected-admin' to OrderController (method updateOrder)
     *  identifiable data: isLoading define as true - to display preloader
     *  takes as arguments: status - type: string - define status of current order in AirTable
     *  sending data: date - type: string of formated date-time
     *                status - type: string
     */
    async submitOrder(status) {
      let msg = '';
      if (status === 'done-admin') {
        msg = this.local_page_keys.alert_you_confirm_sending_of_a_message_order_accepted;
      } else if (status === 'done-admin-for-customer') {
        msg = this.local_page_keys.alert_return_the_order_to_the_customer_without_changes;
      } else {
        msg = this.local_page_keys.alert_you_want_to_reject_the_order;//the confirm's text is determined depending on the status text
      }

      if (!this.isValidSelectProretoucher())
        return;

      let formData = new FormData();
      formData.append('order_id', this.order_id);
      formData.append('pro_retoucher_email', this.selectedUsersForComment.pro_retoucher);
      formData.append('week_comment', this.orderWeekComment);
      if (confirm(msg)) {
        this.$emit('is-loading', true)
        let data;
        try {
          if (this.role === 'test-retoucher') {
            await this.$store.dispatch("postSeniorRetoucher/doneAdmin", {data: formData, role: 'senior-retoucher'});
          } else {
            await this.$store.dispatch("postSeniorRetoucher/doneAdmin", formData);
          }
          data = await this.$store.getters['postSeniorRetoucher/doneAdmin'];
          if (data.status === 'ok' ) {
            if (this.getNewOrder) {
              await this.$store.dispatch("order/getNewOrder");
            }
            //Обновление оценки в рейтинге
            this.$root.$emit('quality-senior-updated', {
              'order_id': this.order_id,
              'quality': 'nice-job',
              'pro_retoucher': this.selectedUsersForComment.pro_retoucher,
            });
            this.$emit('reload', true)
          } else {
            alert(data.message);
            this.$emit('reload', true);
          }
        } catch (e) {
          this.$emit('reload', true);
        }
        this.$emit('is-loading', false)
      }
    },
    /**
     * close re=done-admin window
     */
    closeDialog() {
      this.showDialogEdu = false;
      this.showDialog1 = false;
      this.showDialog9 = false;
      this.fixedPhoto.fields = null;
      this.fixedPhoto.image = null;
      this.classDisplay = '';
    },
    /**
     * send request order 're-done-admin' to OrderController (method updateOrder)
     *
     * */
    async submitComments() {
      let msg = this.local_page_keys.alert_you_confirm_the_sending_of_the_photo_for_redesign;
      let formData = new FormData();
      // console.log(this.showDialogEdu);
      //  console.log(this.role);
      //  return false;

      if (!this.isValidSelectProretoucher())
        return;

      if(this.showDialogEdu){
        formData.append('status', 're-done-admin-education');
        formData.append('education_retoucher_email', this.selectedUsersForComment.retoucher.email);
        formData.append('education_pro_retoucher_email', this.selectedUsersForComment.pro_retoucher);
      } else {
        formData.append('status', 're-done-admin')
      }
      if (this.fixedPhoto.image !== null) {
        this.fixedPhoto.image = convertBase64ToBlob(this.fixedPhoto.image);
        formData.append('fixedPhoto', this.fixedPhoto.image);
        formData.append('comments', this.fixedPhoto.fields);
      }
        // if(this.functionListSelectedVideo.length > 0) {
        //   for (var i = 0; i < this.functionListSelectedVideo.length; i++) {
        //     formData.append('functionListSelectedVideo[]', this.functionListSelectedVideo[i]);
        //   }
        // }
        // if(this.functionListSelectedExample.length > 0) {
        //   for (var i = 0; i < this.functionListSelectedExample.length; i++) {
        //     formData.append('functionListSelectedExample[]', this.functionListSelectedExample[i]);
        //   }
        // }
        // if(this.functionListSelectedDescription.length > 0) {
        //   for (var i = 0; i < this.functionListSelectedDescription.length; i++) {
        //     formData.append('functionListSelectedDescription[]', this.functionListSelectedDescription[i]);
        //   }
        // }
        // if(this.functionListSelectedProblem.length > 0) {
        //   for (var i = 0; i < this.functionListSelectedProblem.length; i++) {
        //     formData.append('functionListSelectedProblem[]', this.functionListSelectedProblem[i]);
        //   }
        // }

      // problem level is BAD if checkbox unchecked (by default) and problem level is TOO BAD if checkbox checked
      this.selectedLevel = this.problemLevel ? this.local_page_keys.option_too_bad : this.local_page_keys.option_bad;

       // formData.append('problem_level', this.selectedLevel);
        formData.append('sendToEducation', this.sendToEducation ? 'education' : 'ordinary');
        formData.append('education_retoucher_email', this.selectedUsersForComment.retoucher.email);
        formData.append('education_pro_retoucher_email', this.selectedUsersForComment.pro_retoucher);
        formData.append('accepted_from_inspector',this.acceptedFromInspector);
        formData.append('sloppy_work',this.sloppyWork);
        formData.append('week_comment', this.orderWeekComment);
        let validForSenretoucher = false;
        let valid = false;
        let validTextArea = false;
        let validTelegramFields = false;
        let validAllertMess = '';
       // let validProblemList = true;
        //let validListSelectedProblem = false;
        valid = this.checked.length !== 0;
        validTextArea = (this.textarea1 !== null && this.textarea1.trim() !== '') || (this.textarea2 !== null && this.textarea2.trim() !== '');

      //  validForSenretoucher = this.fixedPhoto.image !== null && valid;
        validAllertMess = this.fixedPhoto.image !== null ? this.local_page_keys.alert_check_the_function : this.local_page_keys.alert_check_the_function_or_write_a_comment;
       // validListSelectedProblem = this.functionListSelectedProblem.length !== 0;

        if (this.commentForTelegram) {
          validTelegramFields = this.textarea3 !== '' && this.files.length !== 0;
        } else if (!this.commentForTelegram) {
          validTelegramFields = !this.commentForTelegram;
        }

      if (!validTextArea) {
        let textArea = document.querySelector('#validatedTextArea');
        textArea.classList.add('tm-val-error');
        return ;
      }

        // if (!valid && !validTextArea && !validForSenretoucher && !validListSelectedProblem) {
        //   if (validAllertMess === this.local_page_keys.alert_check_the_function_or_write_a_comment) {
        //     let textArea = document.querySelector('#validatedTextArea');
        //     textArea.classList.add('tm-val-error');
        //   }
        //   if(!validListSelectedProblem){
        //     let textArea = document.querySelector('#validatedProblemSelect');
        //     textArea.classList.add('tm-val-error');
        //   }
        //   let checkedFunc = document.querySelector('#checkedFunctions');
        //   if (checkedFunc) {
        //     checkedFunc.classList.add('tm-val-error');
        //     alert(validAllertMess);
        //   }
        // } else if ( !validListSelectedProblem) {
        //   let selectProblem = document.querySelector('#validatedProblemSelect');
        //   if (selectProblem) {
        //     selectProblem.classList.add('tm-val-error');
        //     alert(this.local_page_keys.alert_problem_required)
        //   }
        // } else if ((this.role === 'senior-retoucher' || this.currRole === 'senior-retoucher') && !validTelegramFields) {
        //   let telegInput = document.querySelector('#validatedTextArea3');
        //   telegInput.classList.add('tm-val-error');
        //   let telegFile = document.querySelector('#telegramFile');
        //   telegFile.classList.add('tm-val-error');
        //   alert(this.local_page_keys.alert_fields_required)
        // }


        else {
          // if (this.checked.length > 0) {
          //   formData.append('problem_functions', this.checked);
          // }
          if ((this.textarea1 !== null && this.textarea1.trim() !== '') || (this.textarea2 !== null && this.textarea2.trim() !== '')) {
            let msg = '';
            if (this.textarea1 !== null && this.textarea1.trim() !== '') {
              msg += this.local_page_keys.ordercheck_to_retoucher + ': ' + this.textarea1 + '\n';
              formData.append('problem_comment_retoucher', this.textarea1);
              formData.append('retoucher_email', this.selectedUsersForComment.retoucher.email);
            }
            if (this.textarea2 !== null && this.textarea2.trim() !== '') {
              msg += this.local_page_keys.ordercheck_to_verifier + ' ('+ this.selectedUsersForComment.pro_retoucher + ')' + ': ' + this.textarea2;
              formData.append('problem_comment_pro_retoucher', this.textarea2);
            }
            formData.append('problem_comment', msg);
          }

          formData.append('pro_retoucher_email', this.selectedUsersForComment.pro_retoucher); // для персонализации халтурной работы
          formData.append('retoucher_email', this.selectedUsersForComment.retoucher.email);
          if (this.isPutToVote) {
            formData.append('version_to_vote', this.selectedUsersForComment.retoucher.version);
          }

          if (this.textarea3 !== '') {
            //name, blob, fileName
            formData.append('comment_senior_for_tg', this.textarea3);
          }

          if (this.files.length !== 0) {
            for (let file of this.files) {
              formData.append('file_senior_for_tg[]', file);
            }
          }

          //Для решении проблемы определения ордера при отправки комментария из админки
          formData.append('order_id', this.order_id);
          if (confirm(msg)) {
          // this.$emit('is-loading', true)
            let data;
            try {
              if(this.showDialogEdu){

                await this.$store.dispatch("postSeniorRetoucher/reDoneAdminEducation", formData);
                data = await this.$store.getters['postSeniorRetoucher/reDoneAdminEducation'];

              } else {
                if (this.role === 'test-retoucher') {
                  await this.$store.dispatch("postSeniorRetoucher/reDoneAdmin", {data: formData, role: 'senior-retoucher'});
                } else {

                  await this.$store.dispatch("postSeniorRetoucher/reDoneAdmin", formData);
                }
                data = await this.$store.getters['postSeniorRetoucher/reDoneAdmin'];
              }

              if (data.status === 'ok') {
                if (this.getNewOrder) {
                  await this.$store.dispatch("order/getNewOrder");
                }

                //Обновление оценки в рейтинге
                this.$root.$emit('quality-senior-updated', {
                  'order_id': this.order_id,
                  'isExistBadComment' : this.isBadRatingExist(this.selectedUsersForComment.pro_retoucher),
                  'pro_retoucher': this.selectedUsersForComment.pro_retoucher,
                  'quality': this.acceptedFromInspector ? 'nice-job' : 'bad-job',
                  sloppy_work: this.sloppyWork
                });
                this.$emit('reload', true);
              } else {
                alert(data.message);
                this.$emit('reload', true);
              }
            } catch (e) {
              //alert(data.message);
              this.$emit('reload', true);
            }
            //this.$emit('is-loading', false)
          }
        }
    },
    removeClass() {
      let select = document.querySelector('#select_to_valid');
      select.classList.remove('tm-val-error');
    },
    getlevelsForselect() {
      let select = [];
      select.push(this.local_page_keys.option_not_enough_quality)
      select.push(this.local_page_keys.option_bad_quality)
      return select;
    },
    removeCheckedClass() {
      let checkedFunc = document.querySelector('#checkedFunctions');
      if (checkedFunc) {
        checkedFunc.classList.remove('tm-val-error');
        let textArea = document.querySelector('#validatedTextArea');
        textArea.classList.remove('tm-val-error');
      }
    },
    removeTextAreaClass() {
      let textArea = document.querySelector('#validatedTextArea3');
      textArea.classList.remove('tm-val-error');
    },
    getFunctionList(obj, ret = false){
      let list = [];
      if(typeof obj == 'object') list.push(obj);
      this.faces.forEach(obj => {
        const objKeys = Object.keys(obj);
        if(objKeys.length > 0){
          for(const objKey in obj){
            const valueToRemove = 'super_function';
            if(objKey.indexOf(valueToRemove) < 0){
              //console.log(obj[objKey]);
              list.push({
                value:objKey,
                text: obj[objKey]['RU']
              })
            }
          }
        }
      });
      this.functionList = list;
      if(ret) return list;

    },
    initializeChecked() {
      let faces  = this.faces;
      for (const face of Object.keys(faces)) {
        if (Object.keys(faces[face]).length === 1) {
          for ( const value of Object.keys(faces[face])) {
            this.checked.push(`${face}:${faces[face][value].RU}`);
          }
        }
      }
    },

    setSelectedUsersForComment(user = null, role= null) {
      let selectedProRetoucher =  user && role === 'pro-retoucher' ? user: null ;
      let selectedRetoucher =  user && role === 'retoucher' ? user: null ;

      if(selectedProRetoucher ) {
        this.selectedUsersForComment.pro_retoucher = selectedProRetoucher;
      }

      if(selectedRetoucher) {
        this.selectedUsersForComment.retoucher = selectedRetoucher
      }

    },
    // async getLastRetouchers() {
    //   await this.$store.dispatch("order/lastRetouchers", this.order_id);
    //   const data =  await this.$store.getters['order/lastRetouchers'] ;
    //   this.lastUsersForComment.pro_retoucher = data.pro_retoucher;
    //   this.lastUsersForComment.retoucher = data.retoucher;
    // },
    async getAdminComments() {
      await this.$store.dispatch("order/adminComments", this.order_id);
      const data =  await this.$store.getters['order/adminComments'] ;
      this.adminComments = data;
    },
    isValidSelectProretoucher() {
      let isValid = true
      if (this.selectedUsersForComment.pro_retoucher === null) {
        UIkit.notification({
          message: this.local_page_keys.choosing_pro_retoucher_is_mandatory,
          pos: 'top-center',
          status: 'danger',
          timeout: 1500
        })
        isValid = false;
      }
      return isValid;
    },
    showDialog(dialog) {
      if (!this.isValidSelectProretoucher())
        return;
      this[dialog] = true;
    },
    isProRetoucherComment(){
      let chat = Object.values(this.order_chat);
      let foundElement = chat.filter(item => item.role === 'pro-retoucher' && (item.pro_retoucher_comment !== "" && item.pro_retoucher_comment));
      return foundElement.length > 0;
    },
    //Если была хоть одна пометка о халтуре
    isSloppyWorkExist(){
      let chat = Object.values(this.order_chat);
      let foundElement = chat.filter(item => item.role === 'senior-retoucher' && item.sloppy_work === true);
      return foundElement.length > 0;
    },
    insertQuickResponses(response) {
      this.textarea2 +=  response + '; ';
    },
    isBadRatingExist(email){
      return  this.adminComments.some(feedback => {
        return feedback.email === email && feedback.rating === "bad-job";
      });
    }
  },
  beforeUpdate() {
    this.getFunctionList();
  },
  watch: {
    selectedProRetoucher(newValue, oldValue) {
      if (newValue !== oldValue) {
          this.setSelectedUsersForComment(newValue,'pro-retoucher');
      }
    },
    selectedRetoucher(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setSelectedUsersForComment(newValue,'retoucher');
      }
    }
  },
  computed: {
    selectedProRetoucher() {
      return this.$store.getters['chat/selectedProRetoucher'];
    },
    selectedRetoucher() {
      return this.$store.getters['chat/selectedRetoucher'];
    },
    isPutToVote(){
      return this.selectedUsersForComment.retoucher && this.selectedUsersForComment.retoucher.version;
    }
  },

  async created() {
    if (this.main_photo_after === null) {
      this.beforeModalVisible = true;
    } else {
      this.afterModalVisible = true;
    }
    //await this.getLastRetouchers();
    this.getAdminComments();
    // this.getFunctionList();
     this.initializeChecked();
     await this.setSelectedUsersForComment();
    // console.log(this.faces);
  },
}
</script>

<style scoped>
/*Layout*/
/*@import '../../../../assets/css/uikit/grid.css';*/
/*Utilities*/
/*@import '../../../../assets/css/uikit/background.css';*/
/*@import '../../../../assets/css/uikit/label.css';*/
/*@import '../../../../assets/css/uikit/width.css';*/
/*@import '../../../../assets/css/uikit/height.css';*/
/*@import '../../../../assets/css/uikit/flex.css';*/
/*@import '../../../../assets/css/uikit/margin.css';*/
/*@import '../../../../assets/css/uikit/padding.css';*/
/*@import '../../../../assets/css/uikit/position.css';*/
/*@import '../../../../assets/css/uikit/utility.css';*/
/*@import '../../../../assets/css/uikit/transition.css';*/
/*@import '../../../../assets/css/uikit/text.css';*/
/*@import '../../../../assets/css/uikit/overlay.css';*/
/*@import '../../../../assets/css/uikit/animation.css';*/
@import '../../../../assets/css/custom.css';

/*.tm-file-name {*/
/*  word-break: break-all;*/
/*  line-height: 1;*/
/*}*/

/*.prev-img {*/
/*  width: 60px;*/
/*  height: 60px;*/
/*  background-color: #ccc*/
/*}*/

/*#files-area {*/
/*  border-radius: 6px;*/
/*  border: 3px dashed #e8e8e8;*/
/*  background-color: #f5f5f5;*/
/*  min-height: 70px;*/
/*}*/

/*.file-block {*/
/*  overflow: hidden;*/
/*  border-radius: 6px;*/
/*  background-color: rgba(144, 163, 203, 0.2);*/
/*  margin: 5px 0;*/
/*}*/

/*.tm-file-delete {*/
/*  cursor: pointer;*/
/*  padding: 10px;*/
/*}*/

.main-photo-dialog {
  height: 100%;
}

.left-part-main-photo {
  width: 100%;
}

/*.buttons {*/
/*  display: flex;*/
/*  flex-direction: row;*/
/*  width: 100%;*/
/*}*/

/*.comments-button {*/
/*  border: #297a96 2px solid;*/
/*  border-radius: 5px;*/
/*  width: 75%;*/
/*  height: 90%;*/
/*  background: none;*/
/*  color: #3e3d3d;*/
/*  margin: 2px;*/
/*}*/

.scrollable-dialog {
  max-height: 80% !important;
  overflow-y: auto;
}

.checkFunctions {
  display: contents;
}

/*.image-compare-handle {*/
/*  color: #f10404;*/
/*  background-color: currentColor;*/
/*  cursor: ew-resize;*/
/*  transform: translateX(-50%) translateZ(0);*/
/*  width: 2px;*/
/*  z-index: 2;*/
/*  will-change: left;*/
/*}*/

.display {
  display: none;
}

/*.cancel-order {*/
/*  margin: auto;*/
/*}*/

</style>